import React, { FunctionComponent, useState, useLayoutEffect } from "react";
import * as echarts from "echarts/core";
import {
  ToolboxComponent,
  ToolboxComponentOption,
  TooltipComponent,
  TooltipComponentOption,
  GridComponent,
  GridComponentOption,
} from "echarts/components";
import { LineChart, LineSeriesOption } from "echarts/charts";
import { UniversalTransition } from "echarts/features";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([ToolboxComponent, TooltipComponent, GridComponent, LineChart, CanvasRenderer, UniversalTransition]);

type EChartsOption = echarts.ComposeOption<
  ToolboxComponentOption | TooltipComponentOption | GridComponentOption | LineSeriesOption
>;

interface IProps {
  dataSource: any;
  width: number;
  height: number;
  id: string;
}

var initOption: EChartsOption;

initOption = {
  tooltip: {
    trigger: "axis",
  },
  grid: {
    left: "2%",
    right: "4%",
    bottom: "0",
    containLabel: true,
  },
  toolbox: {},
  xAxis: {
    type: "category",
    boundaryGap: false,
  },
  yAxis: {
    type: "value",
  },
  series: [],
};

const chartColorArr = ["#2fa7ffCC", "#ffa31fCC", "#ff5656CC", "#6ec847CC", "#914EE3CC"];

const SuperTestLineChart: FunctionComponent<IProps> = ({ id, dataSource, width, height }) => {
  const [option, setOption] = useState<EChartsOption>(initOption);

  const initChart = () => {
    let chartDom = document.getElementById(id)!;
    let myChart = echarts.init(chartDom);

    option && myChart.setOption(option, true);
  };

  const createSeries = (data: any[]) => {
    return data.map((item, inx) => ({
      ...item,
      itemStyle: {
        color: inx > 4 ? chartColorArr[inx] : "",
      },
    }));
  };

  const initOptionFn = () => {
    const option = {
      tooltip: {
        trigger: "axis",
        confine: true,
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        show: false,
      },
      yAxis: {
        type: "value",
      },
      series: createSeries(dataSource) as any,
      grid: {
        left: "2%",
        right: "4%",
        bottom: "3%",
        top: "10%",
        containLabel: true,
      },
    };

    option.series = createSeries(dataSource);

    setOption(option as EChartsOption);
  };

  useLayoutEffect(() => {
    initOptionFn();
  }, [dataSource]);

  useLayoutEffect(() => {
    initChart();
  }, [option]);

  return (
    <div className='chart-wrapper'>
      <div id={id} style={{ width: width + "px", height: height + "px" }}></div>
    </div>
  );
};

export default SuperTestLineChart;
